/* ── Bienítu Theme JS ──────────────────────────────────────────────────────── */

/* ── Mobile Menu ─────────────────────────────────────────────────────────── */
(function () {
  const menu = document.getElementById('mobile-menu');
  const openBtn = document.getElementById('menu-open');
  const closeBtn = document.getElementById('menu-close');
  const backdrop = menu && menu.querySelector('.mobile-menu__backdrop');

  if (!menu || !openBtn) return;

  openBtn.addEventListener('click', () => {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
})();

/* ── Product Gallery ─────────────────────────────────────────────────────── */
(function () {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const main = document.querySelector('.product-gallery__main img');

  if (!thumbs.length || !main) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newSrc = thumb.dataset.full || thumb.src;
      main.src = newSrc;
      main.srcset = '';
      main.alt = thumb.alt;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
})();

/* ── Product Tabs / Accordion ────────────────────────────────────────────── */
(function () {
  document.querySelectorAll('.product-tab__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const tab = trigger.closest('.product-tab');
      tab.classList.toggle('is-open');
    });
  });
})();

/* ── Variant Selector ────────────────────────────────────────────────────── */
(function () {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const options = form.querySelectorAll('.variant-option');
  const select = form.querySelector('select[name="id"]');
  const addBtn = form.querySelector('.add-to-cart-btn');
  const priceEl = document.querySelector('.product-info__price');

  options.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.optionIndex;
      form.querySelectorAll(`.variant-option[data-option-index="${group}"]`)
        .forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      updateVariant();
    });
  });

  function updateVariant() {
    if (!select) return;

    // Collect current selections
    const selected = {};
    form.querySelectorAll('.variant-option.selected').forEach(btn => {
      selected[btn.dataset.optionIndex] = btn.dataset.value;
    });

    // Find matching variant option
    let matched = null;
    select.querySelectorAll('option').forEach(opt => {
      const variantOptions = JSON.parse(opt.dataset.options || '[]');
      const matches = variantOptions.every((val, i) => selected[i] === undefined || selected[i] === val);
      if (matches) matched = opt;
    });

    if (matched) {
      select.value = matched.value;
      const price = matched.dataset.price;
      const comparePrice = matched.dataset.comparePrice;
      const available = matched.dataset.available === 'true';

      if (priceEl && price) priceEl.textContent = Shopify.formatMoney(price, window.theme_money_format);
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
    }
  }

  updateVariant();
})();

/* ── Add to Cart ─────────────────────────────────────────────────────────── */
(function () {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('.add-to-cart-btn');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const data = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
      });
      if (!res.ok) throw new Error('Failed to add to cart');
      showToast('Added to bag ✦', 'success');
      updateCartCount();
    } catch {
      showToast('Could not add item. Please try again.', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();

/* ── Cart Count ──────────────────────────────────────────────────────────── */
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  } catch {}
}
updateCartCount();

/* ── Cart Item Controls ──────────────────────────────────────────────────── */
(function () {
  document.querySelectorAll('.cart-item__qty button').forEach(btn => {
    btn.addEventListener('click', async () => {
      const item = btn.closest('.cart-item');
      const lineIndex = item.dataset.lineIndex;
      const currentQty = parseInt(item.querySelector('.cart-item__qty-num').textContent, 10);
      const delta = btn.dataset.action === 'increase' ? 1 : -1;
      const newQty = Math.max(0, currentQty + delta);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: newQty }),
        });
        if (!res.ok) throw new Error();
        if (newQty === 0) {
          item.remove();
        } else {
          item.querySelector('.cart-item__qty-num').textContent = newQty;
        }
        updateCartCount();
        refreshCartTotals();
      } catch {
        showToast('Could not update cart.', 'error');
      }
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const item = btn.closest('.cart-item');
      const lineIndex = item.dataset.lineIndex;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 }),
        });
        item.remove();
        updateCartCount();
        refreshCartTotals();
      } catch {
        showToast('Could not remove item.', 'error');
      }
    });
  });
})();

async function refreshCartTotals() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const totalEl = document.querySelector('.cart-total-price');
    if (totalEl) totalEl.textContent = Shopify.formatMoney(cart.total_price, window.theme_money_format);
  } catch {}
}

/* ── Toast ───────────────────────────────────────────────────────────────── */
function showToast(msg, type = 'success') {
  let toast = document.getElementById('theme-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'theme-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.className = `toast toast--${type} is-visible`;
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
}

/* ── Particle Canvas ─────────────────────────────────────────────────────── */
(function () {
  const canvas = document.getElementById('particle-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let particles = [];
  let raf;

  function resize() {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }

  function createParticles() {
    particles = [];
    const count = Math.floor((canvas.width * canvas.height) / 18000);
    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.2 + 0.3,
        alpha: Math.random() * 0.4 + 0.1,
        vx: (Math.random() - 0.5) * 0.15,
        vy: (Math.random() - 0.5) * 0.15,
      });
    }
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      p.x += p.vx;
      p.y += p.vy;
      if (p.x < 0) p.x = canvas.width;
      if (p.x > canvas.width) p.x = 0;
      if (p.y < 0) p.y = canvas.height;
      if (p.y > canvas.height) p.y = 0;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(176, 140, 73, ${p.alpha})`;
      ctx.fill();
    });
    raf = requestAnimationFrame(animate);
  }

  resize();
  createParticles();
  animate();

  window.addEventListener('resize', () => {
    resize();
    createParticles();
  });
})();
